<template>
    <div class="quiz-container">
        <div class="quiz-content">
            <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>
                    <span class="color-blue" @click="goBackThree">班级管理</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    <span class="color-blue" @click="goBackTwo">{{className}}</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    <span class="color-blue" @click="goBack">小测列表</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{paperName}}</el-breadcrumb-item>
            </el-breadcrumb> -->
            <div style="color: #8F8F8F; margin-bottom: 24px;">
                当前位置：
                <span @click="goBackThree" style="cursor: pointer;">班级管理</span>
                <span @click="goBackTwo" style="cursor: pointer;"> > {{ className }}</span>
                <span @click="goBack" style="cursor: pointer;"> > 小测列表 > </span>
                <span>{{ paperName }}</span>
            </div>
            <div class="quiz-list">
                <div style="display: flex; justify-content: space-between;">
                    <div style="color: #000; font-size: 24px; display: flex; align-items: center;">
                        <div style="width: 6px; height: 32px; background: #006EFF; border-radius: 4px; margin-right: 10px;"></div>
                        小测列表
                    </div>
                    <el-button  type="primary" @click="goBack">返 回</el-button>
                </div>
                <el-table :data="approvedList" style="width: 100%; flex: 1; margin-top: 30px; border: 1px solid #DCDCDC; border-bottom: none; border-radius: 4px;" :header-cell-style="headStyle" :cell-style="cellStyle">
                    <el-table-column prop="s_name" label="学生姓名"></el-table-column>
                    <el-table-column prop="score" label="成绩"></el-table-column>
                    <el-table-column prop="submit_time" label="提交时间"></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.is_read === 1">未批阅</span>
                            <span v-else>已批阅</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="t_name" label="批阅人"></el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-link type="primary" @click="toDetail(scope.row)" :underline="false" style="color: #006EFF">查看</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination class="pages-center" background style="margin: 20px 0;"
                               :current-page.sync="quizPages.currentPageNum"
                               :page-size="quizPages.eachPageNum"
                               :total="quizPages.total"
                               layout="prev, pager, next, jumper"
                               @current-change="quizCurrentChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                quizId: Number(this.$route.query.quizId ) || '',
                classId: Number(this.$route.query.classId ) || '',
                className: this.$route.query.className || '',
                paperName: this.$route.query.paperName || '',
                approvedList: [],
                quizPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0,
                }
            }
        },
        mounted() {
            this.getApprovedList();
        },
        methods: {
            headStyle() {
                return 'background: #F2F4F7; fontWeight: 500; font-family: PingFang SC, PingFang SC; padding-left: 24px; color:#3E3E3E; height: 42px;'
            },
            cellStyle() {
                return 'padding-left: 24px; height: 60px; color: #333;'
            },
            getApprovedList() {
                let params = {
                    quiz_id: this.quizId,
                    c_id: this.classId,
                    is_read: 0,
                    page: this.quizPages.currentPageNum,
                    limit: this.quizPages.eachPageNum,
                }
                this.$shttp.axiosGetBy(this.$api.getRecordList, params, (res) => {
                    if (res.code === 200) {
                        this.approvedList = res.data.data;
                        this.quizPages.total = res.data.total
                    }
                })
            },
            quizCurrentChange(val) {
                this.quizPages.currentPageNum = val;
                this.getApprovedList();
            },
            toDetail(row) {
                this.$router.push({
                    path: '/teacherClass/allApprovedDetail',
                    query: {
                        quizId: this.quizId,
                        studentId: row.s_id,
                        classId: this.classId,
                        className: this.className,
                        paperName: this.paperName,
                        studentName: row.s_name,
                    }
                })
            },
            goBack() {
                this.$router.go(-1)
            },
            goBackTwo() {
                this.$router.go(-2)
            },
            goBackThree() {
                this.$router.go(-3)
            },
        }
    }
</script>

<style scoped lang="scss">
    ::v-deep .el-breadcrumb {
        .el-breadcrumb__inner {
            color: #000;
        }
    }
    .quiz-container {
        width: 100%;
        height: calc(100% - 60px);
        padding: 30px 0;
        .quiz-content {
            width: 1200px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            .quiz-list {
                display: flex;
                flex-direction: column;
                height: calc(100% - 106px);
                padding: 32px 50px;
                background: #fff;
                .course-list {
                    padding: 20px 0 0 0;
                }
            }
        }
    }
</style>